var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"div",staticClass:"drawers",class:_vm.classes},[_vm._t("default",null,{"scrimId":`drawers-scrim-${_vm.$_uid}`}),_vm._v(" "),_c('div',{staticClass:"absolute inset-0",attrs:{"id":`drawers-scrim-${_vm.$_uid}`},on:{"click":function($event){return _vm.$emit('close')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }